module.exports = __webpack_public_path__ + "assets/0dce948d708d7b270cc67c9df41614ce.svg";